<template>
    <div class="subscription-premium-panel white-block">
        <div class="panel-header">
            <h3 class="panel-title">Get more power to deeply engage students in reading.</h3>
            <p class="panel-description">Explore the <a>Premium</a> ReadTheory Experience</p>
        </div>
        <div class="main-container">
          <SubscriptionActivityView @showPlan="showPlanSection" />
          <SubscriptionPassageView @showPlan="showPlanSection" />
          <SubscriptionCompetitionView @showPlan="showPlanSection" />
		  <SubscriptionCuriculumView @showPlan="showPlanSection" />
		  <SubscriptionSettingsView @showPlan="showPlanSection" />
          <SubscriptionPriorityView @showPlan="showPlanSection" />
        </div>
    </div>
</template>

<script>
import SubscriptionActivityView from './SubscriptionActivityView.vue';
import SubscriptionPassageView from './SubscriptionPassageView.vue';
import SubscriptionCompetitionView from './SubscriptionCompetitionView.vue';
import SubscriptionCuriculumView from './SubscriptionCuriculumView.vue';
import SubscriptionSettingsView from './SubscriptionSettingsView.vue';
import SubscriptionPriorityView from './SubscriptionPriorityView.vue';

export default {
  components: {
    SubscriptionActivityView,
    SubscriptionPassageView,
	SubscriptionCompetitionView,
	SubscriptionCuriculumView,
	SubscriptionSettingsView,
    SubscriptionPriorityView
  },
  methods: {
    showPlanSection() {
      $("html, body").animate({ scrollTop: 81 }, "slow");
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-premium-panel {
  padding: 96px 0;
  .panel-title {
    font-family: $title-font;
    font-weight: 700;
    font-size: 36px;
    color: $title-dark-grey;
  }
  .panel-description {
    max-width: 570px;
    margin: 12px auto 0;
    font-size: 16px;
    color: $title-grey;
    text-align: center;
    a {
      font-weight: 700;
      font-size: 16px;
      color: $light-blue2;
    }
  }
  ::v-deep(.view-title) {
    font-weight: 700;
	line-height: 1.3;
	text-align: left;
    font-family: $title-font;
    font-size: 24px;
    color: $title-dark-grey;
  }
  ::v-deep(.view-description) {
	margin-top: 20px;
	text-align: left;
    font-size: 16px;
    color: $title-grey;
  }
  ::v-deep(.feature-image) {
    max-width: 600px;
  }
  ::v-deep(.button-wrapper) {
    width: fit-content;
    margin-top: 24px;
	.primary-button {
	  background: $light-blue2;
	  margin: 0;
	  padding: 16px 32px;
      border: 0;
	}
  }
  @media(max-width: 900px) {
    ::v-deep(.feature-image) {
      max-width: 100%;
    }
  }
  @media(max-width: 767px) {
    padding: 50px 0;
  }
}
</style>
